import SEOHead from '@/components/base/SEOHead';
import CategoryTabs from '@/components/feature/CategoryTabs';
import HeroBanner from './components/HeroBanner';
import FeaturedVideos from './components/FeaturedVideos';
import HotContent from './components/HotContent';
import LatestUpdates from './components/LatestUpdates';
import { getHotArticles, getNewArticles } from '@/mocks/articles';
import VideoCard from '@/components/feature/VideoCard';
import { articles } from '@/mocks/articles';

export default function Home() {
  const hotSidebar = getHotArticles().slice(0, 3);
  const newSidebar = getNewArticles().slice(0, 3);

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '久久视频',
    url: 'https://jiujiu.video',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://jiujiu.video/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '久久视频 - 高清视频在线观看平台',
    description: '久久视频是您的高清视频在线观看首选平台，汇聚海量影视、综艺、短视频内容，流畅播放体验，随时随地畅享精彩视频世界。',
    url: 'https://jiujiu.video',
    isPartOf: {
      '@type': 'WebSite',
      name: '久久视频',
      url: 'https://jiujiu.video',
    },
  };

  return (
    <>
      <SEOHead
        title="高清视频在线观看平台"
        description="久久视频是您的高清视频在线观看首选平台，汇聚海量影视、综艺、短视频内容，流畅播放体验，随时随地畅享精彩视频世界。久久视频让每一次观看都成为享受，立即免费体验。"
        keywords="久久视频,久久视频在线观看,久久视频高清播放,久久视频免费观看,久久视频最新内容,久久视频官网入口,久久视频APP下载"
        canonicalUrl="/"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }}
      />

      <main>
        <HeroBanner />

        <div className="max-w-[1280px] mx-auto px-4 md:px-6 pt-8 md:pt-10">
          <CategoryTabs />
        </div>

        <FeaturedVideos />
        <HotContent />

        <section className="py-10 md:py-14">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2">
                <LatestUpdates />
              </div>
              <aside className="space-y-6">
                <div className="bg-background-100 rounded-lg p-4">
                  <h3 className="text-base font-heading font-bold text-foreground-900 mb-3 flex items-center gap-2">
                    <i className="ri-fire-line text-primary-500"></i>
                    热门排行
                  </h3>
                  <div className="space-y-1">
                    {hotSidebar.map((article, index) => (
                      <VideoCard key={article.id} article={article} variant="compact" />
                    ))}
                  </div>
                </div>
                <div className="bg-background-100 rounded-lg p-4">
                  <h3 className="text-base font-heading font-bold text-foreground-900 mb-3 flex items-center gap-2">
                    <i className="ri-flashlight-line text-accent-500"></i>
                    新鲜速递
                  </h3>
                  <div className="space-y-1">
                    {newSidebar.map((article) => (
                      <VideoCard key={article.id} article={article} variant="compact" />
                    ))}
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6 text-center">
              更多精彩内容
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {articles.slice(0, 8).map((article) => (
                <VideoCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}